import {defaultBenchlingAppsSearchParams} from 'benchling-apps/dashboard/BenchlingAppsSidepanel';
import * as NavConstants from 'constants/NavConstants';
import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const BenchlingAppsRoutes: RouteBundle = {
  domain: 'benchling-apps',
  routes: [
    {urlPattern: 'apps', handler: benchlingAppsSidepanel, legacy: true},
    {
      urlPattern: 'apps/:benchlingAppId',
      handler: EditorRoutes.benchlingAppEditor.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'developer/app-canvas-builder',
      handler: EditorRoutes.benchlingAppCanvasBuilderPage.bind(EditorRoutes),
      legacy: false,
    },
    {
      urlPattern: 'developer/apps',
      handler: EditorRoutes.developerBenchlingAppsPage.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'developer/apps/create',
      handler: EditorRoutes.developerCreateBenchlingAppPage.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'developer/apps/:benchlingAppId',
      handler: EditorRoutes.developerBenchlingAppPage.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'app-catalog/apps/:appDefinitionId/install',
      handler: EditorRoutes.installBenchlingAppPage.bind(EditorRoutes),
      legacy: false,
    },
  ],
};

function benchlingAppsSidepanel(): void {
  EditorRoutes.sidepanelListing(NavConstants.SECTIONS.BENCHLING_APPS, defaultBenchlingAppsSearchParams());
}
